module.exports = __webpack_public_path__ + "img/gas-hydrate.6f05a660.png";